import { UPDATE_COMMON_STATE } from "@/reducers/Common/constant";

interface ActionProps {
  type?: string;
  payload?: any;
}

interface CommonState {
  /** 国家 */
  country: string;
  /** 时间戳 */
  timezone: string;
}

const initState: CommonState = {
  country: 'CN',
  timezone: 'CTT',
};

const reducers = (state = initState, action: ActionProps = {}) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_COMMON_STATE:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default reducers;